import apiV2 from "api-v2";

import type { ImportedQuoteTable } from "../types/imported-quote-table.type";
import { postAnalyzeMultipart, type QuoteImportApi } from "./quote-import-shared";

const ANALYZE_PATH = "rfx-settings/quote-templates/import/analyze";
const APPLY_PATH = "rfx-settings/quote-templates/import/apply";

/**
 * Quote-settings (library) template import — `rfx-settings/quote-templates/import/*`
 * (task 009). Builds on the shared `quote-import-shared.ts` seam (`QuoteImportApi`
 * + `postAnalyzeMultipart` — PRO-574, task 007) rather than re-declaring the
 * interface or the multipart POST helper. Targets the settings surface: one
 * `RfxQuoteTemplate` is persisted per parsed table, with no `rfx`/`rfx_template_id`
 * association.
 *
 * `apply` intentionally discards the `{templates}` response body (the shared
 * `QuoteImportApi` seam's `apply` is `Promise<void>` — see task 010 carry-forward).
 * The caller (`QuoteTemplateSettings`) refreshes the library via
 * `useQuoteTemplates().fetchTemplates()` on `onImportComplete`, which re-fetches
 * through the existing CRUD read path (`normalizeTemplate`) — no FE data-model
 * translation of the apply response is needed.
 */
export const createQuoteSettingsImportApi = (): QuoteImportApi => ({
	analyze: (file: File) => postAnalyzeMultipart(ANALYZE_PATH, file),
	apply: async (tables: ImportedQuoteTable[]): Promise<void> => {
		await apiV2.post(APPLY_PATH, { tables });
	},
});
